"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlPaymentPresentedMethod = void 0;
var PaymentTerminalControlPaymentPresentedMethod;
(function (PaymentTerminalControlPaymentPresentedMethod) {
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["MSR"] = 1] = "MSR";
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["EMV"] = 2] = "EMV";
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["CTLS"] = 3] = "CTLS";
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["CTLS_MSD"] = 4] = "CTLS_MSD";
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["Unknown"] = 5] = "Unknown";
})(PaymentTerminalControlPaymentPresentedMethod = exports.PaymentTerminalControlPaymentPresentedMethod || (exports.PaymentTerminalControlPaymentPresentedMethod = {}));
